import React, { useState, useEffect } from "react";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import Button from "../../../Button/Button";
import { useUpdateTextTempalte } from "../../../../hooks/useContent";

import { InputField1 } from "../../../InputField1/InputField1";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { SimpleTextArea } from "../../../SimpleTextArea/SimpleTextArea";
import { errorMessage } from "../../../../utils/message";

function EditTableText({ show, handleClose, item, setRefresh }) {
  const {
    mutateAsync: updateTextTemplate,
    isLoading: reqLoading,
    isError: reqError,
  } = useUpdateTextTempalte();

  const [initialValues, setValueForm] = useState({
    name: item?.NameTemplate ? item?.NameTemplate : "",
    content: item?.ContentTemplate ? item?.ContentTemplate : "",
  });

  useEffect(() => {
    setValueForm({
      name: item?.NameTemplate ? item?.NameTemplate : "",
      content: item?.ContentTemplate ? item?.ContentTemplate : "",
    });
  }, [item]);

  const handleChange = (e) => {
    const { value, name } = e.target;

    setValueForm({
      ...initialValues,
      [name]: value,
    });
  };

  const validateForm = () => {
    const isOk = true;

    if (initialValues.name.length < 1) {
      errorMessage("لطفا نام را وارد کنید");
      isOk = false;
    } else if (initialValues?.content?.length < 1) {
      errorMessage("لطفا محتوا را وارد کنید");
      isOk = false;
    }
    return isOk;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const queryData = {
        ...initialValues,
        temp_id: item?.IdTemplate,
      };

      updateTextTemplate(queryData).then((res) => {
        setRefresh((before) => !before);
        handleClose();
      });
    }
  };

  return (
    <BootstrapModal
      show={show}
      handleClose={handleClose}
      modaltitle={"ویرایش جدول"}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <UpdateCategoryStyle>
        <RowElementDiv>
          <InputField1
            type="text"
            name="name"
            label="نام فارسی"
            onChange={handleChange}
            value={initialValues?.name}
            placeholder="نام .."
            maxLenght="50"
          />
          <SimpleTextArea
            type="text"
            name="content"
            label="محتوا"
            onChange={handleChange}
            value={initialValues?.content}
            placeholder="کلمات ..."
            maxLenght="50"
          />
        </RowElementDiv>

        <Button
          bgColor={"#4c78a9"}
          small={"100px"}
          className="m-r-1"
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ویرایش
            </Typography>
          )}
        </Button>
        <Button
          className={"mr-2"}
          style={{ marginRight: "10px" }}
          color={"#fff"}
          bgColor={"#f1416c"}
          small={"100px"}
          onclick={handleClose}
        >
          <Typography size={"15px"} primary={"#fff"}>
            انصراف
          </Typography>
        </Button>
      </UpdateCategoryStyle>
    </BootstrapModal>
  );
}

const UpdateCategoryStyle = styled.div``;

const RowElementDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  row-gap: 1rem;
  column-gap: 1rem;
`;
export default EditTableText;
